/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import template from './welcome-political-page.component.html';
import {APP_SHARED} from '../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-welcome-political-page',
  template
})
export class WelcomePoliticalPageComponent {
}
